export enum NotificationType {
  Error,
  Warning,
  Info,
  Success,
}
